/**
 */

define('directives/myservices/packageName/packageName.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('packageName', ['payService','opearteShaService','UserInfo',function (payService,opearteShaService,UserInfo) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope:{
                model:"=",
                packageForm:"="
            },
            templateUrl: '../refactor/directives/myservices/packageName/packageName.template.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {
                $scope.regexp = mainCons.servicesConstant.regexp;
                $scope.webAppUrlCheck = webAppUrlCheck;
                $scope.contains = contains;
                $scope.initData = queryPackageNameOrWeburl;
                $scope.getPNMinLenStr = getPNMinLenStr;
                $scope.isInWhiteList = false;
                $scope.model.getPNSelfTips = getPNSelfTips;

                $scope.model.selected.packageName = '';
                $scope.model.selected.hasPackageName = '';
                $scope.model.selected.webAppUrl = '';

                /**
                 * 校验包名
                 */
                $scope.validPackageName = (function() {
                    var regexp = new RegExp($scope.regexp.packageName);
                    return {
                        test: function(value) {
                            if(!regexp.test(value)){
                                $scope.validPackageNameShowText="应用包名格式错误";
                                return false;
                            }
                            return true;
                        }
                    };
                })();



                /**
                 * 包名自定义弹框错误提示
                 * @returns {*}
                 */
                function getPNSelfTips(){
                    if($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.required){
                        return "请输入包名";
                    } else if ($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.pattern){
                        return $scope.validPackageNameShowText;
                    } else if ($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.minlength && !$scope.packageForm.packageName.$error.pattern){
                        return getPNMinLenStr();
                    }
                    return "";
                }

                function getPNMinLenStr(){
                    return "包名长度不能少于4字符";
                }

                /**
                 * 校验应用访问地址
                 */
                $scope.validateWebAppUrl = (function() {
                    return {
                        test: function(value) {
                            return !webAppUrlCheck(value);
                        }
                    };
                })();

                //包含
                function contains(arr, obj) {
                    return AUI.BaseJSUtil.contains(arr, obj);
                }

                // 应用网址网址校验 不满足返回true
                function webAppUrlCheck(webAppUrl) {
                    webAppUrl = webAppUrl || '';
                    if (webAppUrl.indexOf('*') >= 0) {
                        return true;
                    }
                    return !AUI.BaseJSUtil.checkUrl(webAppUrl) || webAppUrl == '';
                }

                function queryPackageNameOrWeburl(){
                    var appInfo = $scope.model.product.appInfo;
                    $scope.model.selected.packageName = appInfo.packageName || '';
                    $scope.model.selected.hasPackageName = AUI.BaseJSUtil.existy(appInfo.packageName);
                    $scope.model.selected.webAppUrl = appInfo.webAppUrl || '';
                    $scope.validPackageName = (function() {
                        var regexp = new RegExp($scope.regexp.packageName);
                        return {
                            test: function(value) {
                                if(regexp.test(value)){
                                    //相反的注意
                                    return true;
                                }else{
                                    $scope.validPackageNameShowText="应用包名格式错误";
                                    return false;
                                }
                            }
                        };
                    })();
                }
            }
        }
    }]);
});

